import styled from 'styled-components';

export const ContainerCheckBoxGroup = styled.div`
  margin: 5px;
`;
